export default __webpack_public_path__ + "static/media/tutorial-sync-content.b77eb64d6e628c8e8163ee6faf75788f.mp4";